<template>
        <b-row v-if="!app">
            <b-col v-if="!err" align-self="center">
                <b-spinner variant="light" />
            </b-col>

            <b-col v-else align-self="center">
                <b-alert show variant="danger" style="width:100%;text-align:center"> {{ err }} </b-alert>
            </b-col>
            
        </b-row>
        <div v-else>

            <PowerApp 
                :dist="dist" 
                :app="app" 
                :entrypoint="entrypoint"
                v-on="$listeners"
                v-bind="$attrs"
                :key="app.uuid"
                noRouter
                v-if="isViewExported"
            >
                <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
                <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
            </PowerApp>


            <b-alert variant="warning" show v-else>
                View "{{ view }}" is not exported from the app with tag "{{ tag }}"
            </b-alert>
        </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'AppView',
    props: {
        tag: {
            type: String
        },

        view: {
            type: String,
        }
    },
    components: {
        PowerApp: () => import("./PowerApp"),
    },
    data: function() {
        return {
            app: null,
            err: null
        }
    },
    computed: {
        dist() {
            return this.app.dist
        },

        viewsJson() {
            if (this.dist && this.dist['views.json'])
                return JSON.parse(this.dist['views.json'] || '{}')

            return {}
        },

        exportedViews() {
            return _.get(this.viewsJson, 'exportedViews', [])
        },

        isViewExported() {
            return this.entrypoint
        },

        entrypoint() {
            const { entrypoint } = this.exportedViews.find(v => v.view == this.view) || {}

            return entrypoint
        }
    },

    methods: {},  

    async mounted() {
        try {
            let app = await this.$http.get(`/v3/system/gateway/app-service/app/${this.tag}/dist`)
            this.app = app.data

            console.log("app", this.app)
       }  catch(err) {
            this.$debugLog(err)
            this.err = this.$t('failedToRenderAppView')
        }
    }
}
</script>


<style scoped lang="scss">
.settings {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    background-color: var(--bg-card);
    border-radius: 10px 0px 0px 10px;
    right: -45px;
    opacity: 0.5;
    z-index: 9999;

    &.active {
        right: 0;
        opacity: 1;
    }

    .btn {
        display: block;
        margin: 10px;
    }

    .caret {
        position: absolute;
        color: var(--text-primary);
        padding: 10px;
        top: 50%;
        transform: translateY(-50%);
        background-color: inherit;
        padding: 20px 5px;
        left: -15px;
        border-radius: 10px;
        cursor: pointer;
    }
}

</style>

<style>
.tawk-min-container {
    display: none;
}
</style>
